import React, { useEffect, useRef, useState } from "react";
import * as echarts from 'echarts';
import oceano_azul from '../../assets/img/Fundo_oceano.jpg';

function GraficoOceanoAzul({ dados, cargo, tipoGrafico }) {
    const chartRef = useRef(null);

    const [corGrafico, setCorGrafico] = useState(1);
    const [corChecked, setCorChecked] = useState(false);

    const checkboxCorChange = (e) => {
        setCorChecked(e.target.checked);
        if (e.target.checked) {

            setCorGrafico(2);
        } else {
            setCorGrafico(1);
        }
    };

    const [isMobile, setIsMobile] = useState(window.matchMedia('(max-width: 768px)').matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        const handleMediaChange = (e) => {
            setIsMobile(e.matches);
        };

        mediaQuery.addEventListener('change', handleMediaChange);

        if (dados)
            gerarGrafico();

        return () => {
            mediaQuery.removeEventListener('change', handleMediaChange);
        };

    }, [isMobile]);

    useEffect(() => {
        gerarGrafico(isMobile);
    }, [corGrafico]);

    useEffect(() => {
        gerarGrafico(isMobile);
    }, [dados]);

    function gerarGrafico() {
        if (cargo === 'VENDEDOR') {
            return gerarGraficoIndividual(isMobile);
        }

        if (cargo === 'GERENTE_LOJA') {
            return tipoGrafico == 1 ? gerarGraficoIndividual(isMobile) : gerarGraficoGeral();
        }

        if (cargo === 'GERENTE_REGIONAL') {
            return tipoGrafico == 3 ? gerarGraficoIndividual(isMobile) : gerarGraficoGeral();
        }

        return gerarGraficoGeral();
    }

    function gerarGraficoGeral() {
        let chart = echarts.getInstanceByDom(chartRef.current);

        if (!chart) {
            chart = echarts.init(chartRef.current);
        }

        chart.clear();

        const niveis = ['A', 'B', 'C', 'D', 'E'];

        const coresGradiente1 = {
            A: [
                { offset: 0, color: 'rgb(147, 197, 253)' }
            ],
            B: [
                { offset: 0, color: 'rgb(86, 139, 223)' }
            ],
            C: [
                { offset: 0, color: 'rgb(41, 93, 207)' }
            ],
            D: [
                { offset: 0, color: 'rgb(23, 49, 134)' }
            ],
            E: [
                { offset: 0, color: 'rgb(23, 33, 65)' }
            ]
        };

        const coresGradiente2 = {
            A: [
                { offset: 0, color: 'rgb(147, 197, 253)' }
            ],
            B: [
                { offset: 0, color: 'rgb(59, 246, 111)' }
            ],
            C: [
                { offset: 0, color: 'rgb(235, 168, 37)' }
            ],
            D: [
                { offset: 0, color: 'rgb(206, 39, 28)' }
            ],
            E: [
                { offset: 0, color: 'rgb(57, 23, 84)' }
            ]
        };

        const corLegenda1 = ['#172141E5', '#173186E5', '#295DCFE5', '#568BDFE5', '#93C5FDE5'];
        const corLegenda2 = ['#391754E5', '#CE271CE5', '#EBA825E5', '#3BF66FE5', '#93C5FDE5'];

        const coresAtuaisLinhas = corGrafico == 1 ? coresGradiente1 : coresGradiente2;
        const coresAtuaisLegendas = corGrafico == 1 ? corLegenda1 : corLegenda2;

        const dataPorNivel = niveis.reverse().map(nivel => {
            return {
                name: `${nivel}`,
                type: 'line',
                stack: 'Total',
                smooth: true,
                lineStyle: {
                    width: 0
                },
                showSymbol: false,
                areaStyle: {
                    opacity: 0.7,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, coresAtuaisLinhas[nivel])
                },
                emphasis: {
                    focus: 'series'
                },
                data: dados.map(d => {
                    switch (nivel) {
                        case 'E':
                            return d.nivel_e;
                        case 'D':
                            return d.nivel_d;
                        case 'C':
                            return d.nivel_c;
                        case 'B':
                            return d.nivel_b;
                        case 'A':
                            return d.nivel_a;
                    }
                })
            };
        });

        const option = {
            color: coresAtuaisLegendas,
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                },
                order: 'seriesDesc'
            },
            legend: {
                data: niveis.map(nivel => `${nivel}`),
                right: '10%',
            },
            grid: {
                show: true,
                top: '10%',
                left: '3%',
                right: '5%',
                bottom: '7%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: dados.map(d => d.agrupador)
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    axisLabel: {
                        show: false
                    },
                    max: function (value) {
                        return value.max * 1.43;
                    },
                    splitLine: {
                        show: false
                    }
                }
            ],
            series: dataPorNivel,
        };

        chart.setOption(option);

        let tmpCanvas;
        let tmpCanvasCtx;
        const img = new Image();
        img.src = oceano_azul;
        img.onload = function () {
            updateBackgroundImage();
            window.addEventListener("resize", function () {
                chart.resize();
                updateBackgroundImage();
            });
        };

        function updateBackgroundImage() {
            const rect = chart._api.getCoordinateSystems()[0].getRect();
            if (!tmpCanvas) {
                tmpCanvas = document.createElement("canvas");
                tmpCanvasCtx = tmpCanvas.getContext("2d");
            }

            tmpCanvas.width = rect.width + rect.x;
            tmpCanvas.height = rect.height + rect.y;

            tmpCanvasCtx.drawImage(img, rect.x, rect.y, rect.width, rect.height);

            chart.setOption({
                grid: {
                    backgroundColor: {
                        image: tmpCanvas,
                        repeat: "no-repeat"
                    }
                }
            });
        }

        return () => {
            chart.dispose();
        };
    }

    function gerarGraficoIndividual(isMobileParametro) {
        let chart = echarts.getInstanceByDom(chartRef.current);

        if (!chart) {
            chart = echarts.init(chartRef.current);
        }

        chart.clear();

        const eixoX = dados.map(item => item.agrupador);
        const eixoY = dados.map(item => item.nivel_indice);
        const nivel = dados.map(item => item.nivel);
        const pontuacao = dados.map(item => item.pontuacao);

        const tituloGrafico = {
            text: 'Oceano Azul',
            textStyle: {
                color: '#176fac',
                fontSize: '1.875rem',
                fontWeight: '700',
                fontFamily: 'Poppins'
            },
            left: 'center'
        };

        const coresGradiente1 = [
            { offset: 0, color: 'rgba(147, 197, 253, 1)' },
            { offset: 0.25, color: 'rgba(86, 139, 223, 0.9)' },
            { offset: 0.5, color: 'rgba(41, 93, 207, 1)' },
            { offset: 0.75, color: 'rgba(23, 49, 134, 1)' },
            { offset: 1, color: 'rgba(23, 33, 65, 1)' }
        ];

        const coresGradiente2 = [
            { offset: 0, color: 'rgba(147, 197, 253, 1)' },
            { offset: 0.25, color: 'rgba(59, 246, 111, 0.9)' },
            { offset: 0.5, color: 'rgba(235, 168, 37, 1)' },
            { offset: 0.75, color: 'rgba(206, 39, 28, 1)' },
            { offset: 1, color: 'rgba(57, 23, 84, 1)' }
        ];

        const coresAtuaisLinhas = corGrafico == 1 ? coresGradiente1 : coresGradiente2;

        const option = {
            title: cargo === 'VENDEDOR' && tituloGrafico,
            tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                    return `<div style="text-align: center;">
                                    <div>Nível: ${nivel[params[0].dataIndex]}</div>
                                    <div>Pontuação: ${pontuacao[params[0].dataIndex]}</div>
                                </div>`;
                },
            },
            grid: {
                show: true,
                top: '10%',
                left: '3%',
                right: '5%',
                bottom: '7%',
                containLabel: true,

            },
            xAxis: {
                type: 'category',
                data: eixoX,
                boundaryGap: false,
            },
            yAxis: {
                type: 'value',
                min: 0,
                max: 4 * 1.43,

                axisLabel: {
                    fontFamily: 'Arial',
                    fontSize: 12,
                    formatter: function (value) {
                        switch (value) {
                            case 4:
                                return 'A';
                            case 3:
                                return 'B';
                            case 2:
                                return 'C';
                            case 1:
                                return 'D';
                            case 0:
                                return 'E';
                            default:
                                return '';
                        }
                    }
                },
                splitLine: {
                    show: false
                }
            },
            series: [
                {
                    data: eixoY,
                    name: 'Email',
                    type: 'line',
                    smooth: 0.7,
                    showSymbol: false,
                    lineStyle: {
                        color: 'rgba(0, 0, 0, 0)',
                        width: 1,
                    },
                    itemStyle: {
                        color: 'rgba(47, 51, 153, 1)',
                    },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, coresAtuaisLinhas),
                    },
                },
            ],
        };

        if (isMobileParametro) {
            chart.setOption({
                dataZoom: [
                    {
                        type: 'slider',
                        xAxisIndex: 0,
                        zoomLock: true,
                        height: 10,
                        bottom: 0,
                        start: 0,
                        end: 50,
                        handleSize: 0,
                        showDetail: false,
                        showDataShadow: false,
                    },
                    {
                        type: 'inside',
                        id: 'insideX',
                        xAxisIndex: 0,
                        start: 0,
                        end: 50,
                        zoomOnMouseWheel: false,
                        moveOnMouseMove: true,
                        moveOnMouseWheel: true,
                    },
                ]
            }, { replaceMerge: 'dataZoom' });


        } else {
            chart.setOption({
                dataZoom: []
            }, { replaceMerge: 'dataZoom' });
        }

        chart.setOption(option);

        let tmpCanvas;
        let tmpCanvasCtx;
        const img = new Image();
        img.src = oceano_azul;
        img.onload = function () {
            updateBackgroundImage();
            window.addEventListener("resize", function () {
                chart.resize();
                updateBackgroundImage();
            });
        };

        function updateBackgroundImage() {
            const rect = chart._api.getCoordinateSystems()[0].getRect();
            if (!tmpCanvas) {
                tmpCanvas = document.createElement("canvas");
                tmpCanvasCtx = tmpCanvas.getContext("2d");
            }

            tmpCanvas.width = rect.width + rect.x;
            tmpCanvas.height = rect.height + rect.y;

            tmpCanvasCtx.drawImage(img, rect.x, rect.y, rect.width, rect.height);

            chart.setOption({
                grid: {
                    backgroundColor: {
                        image: tmpCanvas,
                        repeat: "no-repeat"
                    }
                }
            });
        }

        return () => {
            chart.dispose();
        };
    }

    return (
        <>
            <section>
                <div className="container">
                    <div className="mb-8">
                        <div ref={chartRef} style={{ width: "100%", height: "600px" }}></div>
                        <div className="flex justify-center mb-4 font-extrabold text-gray-c2 text-sm mt-2">
                            <label className="inline-flex items-center me-5 cursor-pointer">
                                <input type="checkbox" value="" className="sr-only peer" checked={corChecked} onChange={checkboxCorChange} />
                                <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-red-300 dark:peer-focus:ring-red-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
                                <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Multicor</span>
                            </label>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default GraficoOceanoAzul